import keycloak from '../../plugins/keycloak'

export default {
  namespaced: true,
  state: {},
  actions: {
    logout: () => {
      localStorage.removeItem('user')
      keycloak.logout({ redirectUri: location.origin + '/' })
    }
  },
  mutations: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/credentials.js